export const CharCounter = ({
  current,
  max
}: {
  current: number;
  max: number;
}) => (
  <span
    aria-hidden="true"
    className="absolute bottom-4 right-3 text-xs font-medium text-content-100 pointer-events-none"
  >
    {current}/{max}
  </span>
);
